import { getTopicLabel, getTypeLabel, getLanguageLabel } from '../../tools';

export function CurrentFilters(props) {
	if ( props.filterTopics.length === 0 &&
		props.filterDocumentTypes.length === 0 &&
		props.filterLanguages.length === 0 ) {
		return;
	}
	return (
		<div className='toolkit--current-fitlers'>
			{props.filterTopics.map(item => (
				<button className='toolkit--current-fitlers--pill' key={item} onClick={(event) => props.clearFilter(event, 'topic', item)}>{getTopicLabel(item)}</button>
			))}
			{props.filterDocumentTypes.map(item => (
				<button className='toolkit--current-fitlers--pill' key={item} onClick={(event) => props.clearFilter(event, 'type', item)}>{getTypeLabel(item)}</button>
			))}
			{props.filterLanguages.map(item => (
				<button className='toolkit--current-fitlers--pill' key={item} onClick={(event) => props.clearFilter(event, 'language', item)}>{getLanguageLabel(item)}</button>
			))}
			<button className="toolkit--current-fitlers--clear-all" onClick={props.clearAllFilters}>Clear filter</button>
		</div>
	)
}
export default CurrentFilters;
